module.exports = __webpack_public_path__ + "media/images/new_landing/case/case-henkel-block-2-887a0fc1ac6436946fca41f38ae1cfc9.jpg";